<template>
  <body>
  </body>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {
      let accountCode = this.$route.query.accountCode
      let langType = this.$route.query.langType

      console.log('accountCode === ' + accountCode)
      console.log('langType === ' + langType)

      this.superLogin(accountCode,langType)
    },
    methods: {
      superLogin(accountCode,langType){
        this.$axios.get('/api/clienth5/login', {
          params: {
            "accountCode": accountCode,
            "langType": langType
          }
        })
        .then(response => {
          console.log('超级登录接口数据返回')
          console.log(response)
          let code = response.code
          let data = response.data
          let message = response.msg
          if(code == '0'){
            if(langType == 'CN'){
              localStorage.setItem('locale', 'zh')
            }else{
              localStorage.setItem('locale', 'en')
            }
            this.userPermission()
          }else if(code == '-1'){
            this.$message.error(message)
          }
        })
        .catch(error => {
          console.log(error);
          this.abnormalSituation()
        });
      },
      //获取用户权限
      userPermission() {
        this.$axios.get('/menu/userPermission',{
          params: {

          }
        })
        .then(response => {
          console.log('获取用户权限接口返回数据:↓↓↓')
          console.log(response)
          let status = response.code
          let message = response.msg
          let data = response.data
          if(status==0){
            // 缓存权限列表用于主页面显示tabbar判断
            localStorage.setItem('permissionList',data)
            // 根据权限列表决定登录后跳转的页面地址：ex用户拥有所有权限跳转到企业账户总览，用户只有个人账号权限跳转到个人账户总览
            // 判断顺序为tabbar显示顺序
            // 企业账户总览
            if(data && data.indexOf('user:company:account') != -1){
              this.$router.push({
                name: "accountmodel"
              })
            // 企业关联账号管理
            }else if(data && data.indexOf('user:company:accountmanage') != -1){
              this.$router.push({
                name: "managementmodel"
              })
            // 个人账户总览
            }else if(data && data.indexOf('user:person:account') != -1){
              this.$router.push({
                name: "personalmodel"
              })
            }
          }else if(status==-1){
            this.$toast(message)
          }
        })
        .catch((error) => {
          console.log(error);
          this.abnormalSituation()
        });
      },
    },
    components: {

    }
  }
</script>

<style>
</style>
